<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12"></div>
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Μέλη ομάδας</h4>

            <div class="table-responsive">
              <table class="table mb-0">
                <thead class="table-light">
                  <tr>
                    <th>A/A</th>
                    <th>Ρόλος</th>
                    <th>Σύνολο</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(role, index) in roles" :key="index">
                    <th scope="row">{{ index + 1 }}</th>
                    <td>
                      {{ parsePeopleRoles(role.role) }}
                    </td>
                    <td>{{ role.count }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapState, mapGetters } from "vuex";
import { translateRole } from "../../../translate_roles";

export default {
  page: {
    title: "ΜΕΛΗ ΟΜΑΔΑΣ",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Μελη ομαδας",
      items: [
        {
          text: "Μέλη Ομάδας",
          href: "/",
        },
      ],
    };
  },
  computed: {
    ...mapState("utils", ["roles", "standarRoles"]),
    ...mapGetters("auth", ["userDetails", "userRole"]),
  },

  methods: {
    translateRole,

    parsePeopleRoles(role) {
      return this.standarRoles
        .map((e) => {
          if (role == e.id) {
            return translateRole(e.name);
          }
        })
        .filter((o) => o != null)
        .join("");
    },
  },
};
</script>
